import React, { useEffect, useState, useRef } from 'react'
import { FormattedMessage } from 'react-intl';
import API from '../../utils/API'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import constants from '../../utils/constants'

function Orchestrate(props) {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission)=>{
    return permission.id
  })

  useEffect(() => {
    if(!permissionIds.includes(constants.permissionIds.licensesEdit)){
      navigate('/forbidden');
    };
  }, [navigate, permissionIds]);

  return (
    <div>
      <div className='d-flex'>
        <main>
          <h3 className='title'>Orchestrate</h3>
          <a href={`${window.location.origin}/orchestrate`} className='link-text' target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="GO_TO_ORCHESTRATE" />
          </a>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Orchestrate)